import React, { FC } from 'react';

import delv from 'dlv';
import { useIntl } from 'react-intl';

import {
  ImageContainer,
  RewardPoints,
  RewardsTitleContainer,
} from 'components/app-header/loyalty/scan-rewards/components/styled';
import Picture from 'components/picture';
import { useCustomizableContent } from 'state/customizable-content';

import { PointsColumn, Subtitle } from './tims-rewards-points.styled';
import { ITimsRewardsPoints } from './types';

export const TimsRewardsPoints: FC<ITimsRewardsPoints> = ({ points = 0, showSubtitle = false }) => {
  const { formatMessage } = useIntl();
  const { loyaltyContent } = useCustomizableContent();

  const timsRewardsImage = delv(loyaltyContent, 'timsRewardsImage.locale');
  return (
    <RewardsTitleContainer tabIndex={0}>
      <ImageContainer>
        <Picture
          data-testid="tim-rewards-logo"
          image={timsRewardsImage}
          alt={formatMessage({ id: 'timsRewards' })}
          objectFitContain
        />
      </ImageContainer>
      <PointsColumn>
        {showSubtitle && (
          <Subtitle data-testid="tims-rewards-points-subtitle">
            {formatMessage({ id: 'rutrYouHave' })}
          </Subtitle>
        )}
        <RewardPoints data-testid="tim-rewards-loyalty">
          {formatMessage({ id: 'loyaltyDropdownPoints' }, { points })}
        </RewardPoints>
      </PointsColumn>
    </RewardsTitleContainer>
  );
};
